import '@/javascripts/jquery-setup';
import 'jquery-modal';

type JQueryWithModal = JQueryStatic & {
  modal: {
    close: () => void;
  };
};
type JQueryModalElement = JQuery & {
  modal: (options?: { escapeClose?: boolean; clickClose?: boolean }) => JQuery;
};

export const initAdminMessageNotificationModal = () => {
  const modalEl = document.getElementById('admin_message_notification_modal');
  if (!modalEl) return;
  if (modalEl.dataset.initialized === 'true') return;
  modalEl.dataset.initialized = 'true';

  const notifiedPath = modalEl.dataset.notifiedPath;
  const openPath = modalEl.dataset.openPath;
  const notificationScope = modalEl.dataset.notificationScope ?? 'single';
  if (!notifiedPath) return;

  const $ = (window as Window & { jQuery?: JQueryStatic }).jQuery as JQueryWithModal | undefined;
  if (!$) return;

  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
  let notified = false;
  let notifying = false;

  const markNotified = async () => {
    if (notified || notifying) return;

    notifying = true;
    try {
      const response = await fetch(notifiedPath, {
        method: 'PATCH',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken ?? '',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ notification_scope: notificationScope }),
      });
      if (!response.ok) throw new Error(`admin message modal notification failed: ${response.status}`);
      notified = true;
    } catch (e) {
      console.error('Failed to mark admin message modal as notified', e);
    } finally {
      notifying = false;
    }
  };

  ($(modalEl) as JQueryModalElement).modal({
    escapeClose: false,
    clickClose: false,
  });

  modalEl.querySelectorAll('.js-admin-message-modal-close').forEach((element) => {
    element.addEventListener('click', async (event) => {
      event.preventDefault();
      await markNotified();
      $.modal.close();
    });
  });

  modalEl.querySelector('.js-admin-message-modal-open-thread')?.addEventListener('click', async () => {
    await markNotified();
    if (openPath) window.location.href = openPath;
  });
};
